import Collections from './Collections';
import Groups from './Groups';
import Levels from './Levels';

export default { Collections, Groups, Levels };
